const types = {
  actions: {
    addToast: 'addToast',
    removeToast: 'removeToast'
  }
};

export default types;
